import { render } from "./ArticlesList.vue?vue&type=template&id=14f1085a"
import script from "./ArticlesList.vue?vue&type=script&lang=js"
export * from "./ArticlesList.vue?vue&type=script&lang=js"

import "./ArticlesList.vue?vue&type=style&index=0&id=14f1085a&lang=css"

import exportComponent from "E:\\moneyman\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__